import React , { useState }from 'react';
import {
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import logoRN from '../../assets/images/logo-dibox-rn.png';
import loginFunction from './login.functions';

const Login = () => {

  const history = useHistory();
  const [auth, setAuth] = useState(false);
  const [message, setMessage] = useState('');
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = data => {
    loginFunction.login(data).then((response) => {
      if (response.login) {
        history.replace('/');
      } else {
        setAuth(true);
        setMessage(response.message);
      }
    });
  }

  return(
    <>
    <Container fluid={true}>
      <Row>
        <Col className="p-0" lg={9}>
          <div className="brand-login backgroud-brand">
            <div className="text-login-brand">
              <h1>Gestiona y organiza</h1>
              <span>Consolida tus cargas en un solo lugar.</span>
            </div>
          </div>
        </Col>
        <Col className="p-0" lg={3}>
            <form className="login-container" onSubmit={handleSubmit(onSubmit)}>
              <div className="logo-position">
                <img alt="Dibox Platform" src={logoRN} className="img-fluid" />
              </div>
              <div className="grupo-input-login">
                <small>Usuario</small>
                <input autoComplete="off" className={`form-control input-border ${errors.username && "is-invalid"}`} name="username" placeholder="Ingrese su usuario" ref={register({ required: true })} />
              </div>
              <div className="grupo-input-login">
                <small>Contraseña</small>
                <input autoComplete="off" className={`form-control input-border ${errors.password && "is-invalid"}`} name="password" type="password" placeholder="Ingrese su contraseña" ref={register({ required: true })} />
              </div>
              <div className="d-flex justify-content-end grupo-input-login">
               <button type="submit" className="btnx btnx-warn">
                 Iniciar Sesión
               </button>
              </div>
              <div className="dbxAlertUser">
                {auth ? <div className="fail-login">{message}</div> : null}
              </div>
            <div className="author-login">
              V{process.env.REACT_APP_VERSION_PLATFORM} - Powered by <span>DIMOIT</span>
            </div>
            </form>
        </Col>
      </Row>
    </Container>
    </>
  )
}

export default Login;